const actions = {
  resetState(context) {
    context.commit('resetState');
  }
};

export default actions;
